// store_info/StoreInfoGql.js
import { gql } from "@apollo/client";

/* ************************************************
 * STORE_INFO Apollo Graphql
 * Project: NewTOP for cloud
 * 2024-08-29 17:39:54 using DbdbTap
 ************************************************ */

const SIMPLE_STORE_INFO_LIST_PART = gql`
fragment SimpleStoreInfoListPart on StoreInfo {
    storeId
    storeTypeCd
    storeTypeName
    storeName
    useYn
}
`;

const STORE_INFO_LIST_PART = gql`
fragment StoreInfoListPart on StoreInfo {
    storeId
    storeTypeCd
    storeTypeName
    storeName
    zipCd
    addr
    officeTelno
    storeStaffName
    secuTelno
    secuStaffName
    totTelno
    useYn
    fillRateYn
    regDate
    regUser
    regUserName
}
`;

/*

    reserve
    점포구분.........storeTypeCd
    점포코드.........storeId
    점포명...........storeName
    우편번호............zipCd
    주소...............addr
    점포 연락처........officeTelno
    점포 담당자........storeStaffName
    보안실 연락처......secuTelno
    보안 담당자........secuStaffName
    종합사무실 연락처.....totTelno
*/


export const LIST_STORE_INFO = gql`
${STORE_INFO_LIST_PART}
query ListStoreInfo {
    storeInfoList {
        ...StoreInfoListPart
    }
}
`;

export const LIST_USING_STORE_INFO = gql`
${SIMPLE_STORE_INFO_LIST_PART}
query ListUsingStoreInfo {
    storeInfoListUsing {
        ...SimpleStoreInfoListPart
    }
}
`;

export const GET_STORE_INFO = gql`
${STORE_INFO_LIST_PART}
query GetStoreInfo($storeId:String!) {
    storeInfoItem(storeId:$storeId) {
        ...StoreInfoListPart
    }
}
`;


export const ADD_STORE_INFO = gql`
mutation AddStoreInfo($storeInfo:InputStoreInfoAdd!) {
	storeInfoAdd(storeInfo: $storeInfo) {
		ok
		message
	}
}
`;

export const EDIT_STORE_INFO = gql`
mutation EditStoreInfo($storeInfo:InputStoreInfoEdit!) {
	storeInfoEdit(storeInfo: $storeInfo) {
		ok
		message
	}
}
`;

// storeInfoEditPeople(storeInfo: InputStoreInfoEditPeople!): CommonResponse
export const EDIT_STORE_INFO_PEOPLE = gql`
mutation EditStoreInfoPeople($storeInfo:InputStoreInfoEditPeople!) {
    storeInfoEditPeople(storeInfo: $storeInfo) {
        ok
        message
    }
}
`;

export const REMOVE_STORE_INFO = gql`
mutation RemoveStoreInfo($storeInfo:InputStoreInfoRemove!) {
	storeInfoRemove(storeInfo: $storeInfo) {
		ok
		message
	}
}
`;

/*
storeInfoSetZone(storeInfo: InputStoreInfoSetZone!): CommonResponse

input InputStoreInfoSetZone {
    storeId: String!
    lat: Float!
    lon: Float!
    xCoord: Float!
    yCoord: Float!
    zoneShape: String
    useZone: Boolean!
}
*/

export const SET_ZONE_STORE_INFO = gql`
mutation SetZoneStoreInfo($storeInfo:InputStoreInfoSetZone!) {
    storeInfoSetZone(storeInfo: $storeInfo) {
        ok
        message
    }
}
`;

// storeInfoSetUsage(storeInfo: InputStoreInfoSetUsage!): CommonResponse
export const SET_USAGE_STORE_INFO = gql`
mutation SetUsageStoreInfo($storeInfo:InputStoreInfoSetUsage!) {
    storeInfoSetUsage(storeInfo: $storeInfo) {
        ok
        message
    }
}
`;

// storeInfoListUnsafe: [StoreInfoSimple]!
export const LIST_STORE_INFO_UNSAFE = gql`
query ListStoreInfoUnsafe {
    storeInfoListUnsafe {
        storeId
        storeName
    }
}
`;
